import axios from 'axios';

const API_URL = `${process.env.REACT_APP_SERVICE_URL}rooms`;

export const getAllRooms = async () => {
    return axios.get(API_URL);
};

export const getRoomById = async (id) => {
    return (await axios.get(`${API_URL}/${id}`));
};

export const createRoom = async (Name,RoomNumber, Status) => {
    return axios.post(API_URL, { Name,RoomNumber, Status });
};

export const updateRoom = async (roomData) => {
    console.log("Updating room with ID:", roomData.ID);

    const { Name, RoomNumber, Status } = roomData; 
    return axios.put(`${API_URL}/${roomData.ID}`, { Name, RoomNumber, Status });
};

export const deleteRoom = async (id) => {
    return axios.delete(`${API_URL}/${id}`);
};
